import type { IImageConfig } from 'components/atoms/image/entities/types';
import { EProductType } from 'src/shared/types/product-type';

export const ASSETS_BASE_PATH = '/tp/static/assets/img/header-v2';

export const defaultLogoLightPaths: Record<EProductType, string> = {
    [EProductType.Klaxoon]: `${ASSETS_BASE_PATH}/klaxoon-logo-light-v2.svg`,
    [EProductType.Wrike]: `${ASSETS_BASE_PATH}/wrike-logo-light-v2.svg`,
};

export const imageConfig: IImageConfig = {
    sources: [
        {
            media: '(min-width: 1280px)',
            sizes: {
                value: 256,
                unit: 'px',
            },
        },
        {
            media: '(min-width: 768px)',
            sizes: {
                value: 226,
                unit: 'px',
            },
        },
        {
            media: '(min-width: 320px)',
            sizes: {
                value: 256,
                unit: 'px',
            },
        },
        {
            media: '',
            sizes: {
                value: 256,
                unit: 'px',
            },
        },
    ],
};
